<mat-form-field class="w-100" appearance="outline">
    <mat-label>{{ label | translate }}</mat-label>

    <input matInput readonly
        [matDatepicker]="picker"
        [formControlName]="fieldName"
        [required]="required"
        (click)="picker.open()">
    <mat-icon *ngIf="!required && !disabled" matSuffix class="mat-datepicker-toggle clickable" (click)="clearField()">clear</mat-icon>
    <mat-datepicker #picker></mat-datepicker>
    
    <mat-error *ngIf="getFormControlField()?.hasError('required')">
        {{ 'data-table.validation.field-required' | translate }}
    </mat-error>
    
    <mat-error *ngIf="getFormControlField()?.hasError('dateInYear')">
        {{ 'data-table.validation.date-in-year' | translate : { selectedYear: getFormControlField()?.getError('dateInYear')['year'] } }}
    </mat-error>
</mat-form-field>
